// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__3GcMI","image":"recipe_image__3mEvj"};